import { AddVehicleCategoryPanel } from "@/components/organisms";

export const VehicleCategoriesAdd = () => {
  return <AddVehicleCategoryPanel />;
};
